import ChannelMenu, { type ScopeNode } from "@/components/ChannelMenu";
import Inline from "./progress/Inline";
import MonthProgress from "./progress/MonthProgress";
import SectionHeading from "./progress/SectionHeading";
import type { ProgressProps } from "./progress/types";
import YearProgress from "./progress/YearProgress";

interface Props {
  plan: { begin_date: string; end_date: string; currency: string | null };
  progress: ProgressProps;
  scopeTree: ScopeNode[];
  scope: { id: string; name: string };
  hrefForScope: (slug: string) => string;
  categoryTree: ScopeNode[];
  category: { id: string; name: string } | null;
  hrefForCategory: (slug: string) => string;
}

// The Overview section: Scope and Category (shared with the table below), then the plan period's
// and the current month's progress cards.
export default function ActualsOverview({ plan, progress, ...props }: Props) {
  return (
    <>
      <SectionHeading title="Overview">
        <div className="flex flex-wrap items-center gap-5">
          <Inline label="Scope">
            <ChannelMenu
              scopeTree={props.scopeTree}
              currentNodeId={props.scope.id}
              currentNodeName={props.scope.name}
              hrefForChannel={props.hrefForScope}
              requireLeaf={false}
            />
          </Inline>
          <Inline label="Category">
            <ChannelMenu
              scopeTree={props.categoryTree}
              currentNodeId={props.category?.id ?? "all"}
              currentNodeName={props.category?.name ?? "All categories"}
              hrefForChannel={props.hrefForCategory}
              requireLeaf={false}
              label="Category"
            />
          </Inline>
        </div>
      </SectionHeading>
      {/* Today outside the plan's dates has no current month: the year card alone, full width. */}
      <div className={progress.month ? "grid grid-cols-1 gap-4 xl:grid-cols-2" : "grid grid-cols-1 gap-4"}>
        <YearProgress
          currency={plan.currency}
          planBegin={plan.begin_date}
          planEnd={plan.end_date}
          trendDays={progress.trend_days}
          year={progress.year}
        />
        {progress.month && (
          <MonthProgress currency={plan.currency} recentDays={progress.recent_days} month={progress.month} />
        )}
      </div>
    </>
  );
}
